import { render, staticRenderFns } from "./ProblemRelationModal.vue?vue&type=template&id=2e2bcff8&scoped=true"
import script from "./ProblemRelationModal.vue?vue&type=script&lang=js"
export * from "./ProblemRelationModal.vue?vue&type=script&lang=js"
import style0 from "./ProblemRelationModal.vue?vue&type=style&index=0&id=2e2bcff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bcff8",
  null
  
)

export default component.exports